import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Tooltip as ReactTooltip } from "react-tooltip";

const ClickableTooltip = ({
  children,
  text,
  id,
  loading,
  isNightMode: initialNightMode,
  place,
  auth,
  custom,
  tooltipContent,
  containerStyle
}) => {
  const [isOpenOnHover, setIsOpenOnHover] = useState(false);
  const [isOpenOnClick, setIsOpenOnClick] = useState(false);
  const isNightMode = useMemo(() => {
    if (typeof initialNightMode === "boolean") {
      return initialNightMode;
    }
    return auth.isNightMode;
  }, [auth, initialNightMode]);

  return (
    <React.Fragment>
      {custom ? (
        <React.Fragment>
          <button
            loading={loading}
            style={{
              ...containerStyle,
              border: "none",
              background: "none",
              marginLeft: "0px !important"
            }}
            id={id}
            data-tooltip-variant={isNightMode ? "dark" : "light"}
            onClick={() => setIsOpenOnClick((prev) => !prev)}
            onMouseEnter={() => setIsOpenOnHover(true)}
            onMouseLeave={() => setIsOpenOnHover(false)}
          >
            {children}
          </button>
          <ReactTooltip
            anchorId={id}
            className={`custom-tooltip ${isNightMode ? "dark" : "light"}`}
            effect="solid"
            place={place || "left"}
            isOpen={isOpenOnClick || isOpenOnHover}
            style={{
              maxHeight: 400,
              overflow: "auto",
              pointerEvents: "auto",
              maxWidth: 500
            }}
          >
            {tooltipContent}
          </ReactTooltip>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <button
            loading={loading}
            style={{
              ...containerStyle,
              border: "none",
              background: "none",
              marginLeft: "0px !important"
            }}
            id={id}
            data-tooltip-content={text}
            data-tooltip-variant={isNightMode ? "dark" : "light"}
            onClick={() => setIsOpenOnClick((prev) => !prev)}
            onMouseEnter={() => setIsOpenOnHover(true)}
            onMouseLeave={() => setIsOpenOnHover(false)}
          >
            {children}
          </button>
          <ReactTooltip
            anchorId={id}
            className={`custom-tooltip ${isNightMode ? "dark" : "light"}`}
            effect="solid"
            place={place || "left"}
            isOpen={isOpenOnClick || isOpenOnHover}
            style={{
              maxHeight: 400,
              overflow: "auto",
              pointerEvents: "auto",
              maxWidth: 500
            }}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
ClickableTooltip.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  id: PropTypes.string,
  loading: PropTypes.bool,
  isNightMode: PropTypes.bool,
  place: PropTypes.string,
  auth: PropTypes.object,
  custom: PropTypes.bool,
  tooltipContent: PropTypes.node,
  containerStyle: PropTypes.object
};
function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth
  };
}

export default connect(mapStatesToProps)(ClickableTooltip);

// export default ClickableTooltip;
